export function createOcrRateChart (documentRoot, sources) {
  const svgNode = (tag, attributes = {}, text) => {
    const node = documentRoot.createElementNS('http://www.w3.org/2000/svg', tag);
    for (const [key, value] of Object.entries(attributes)) node.setAttribute(key, value);
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const region = documentRoot.createElement('div');
  region.className = 'ocr-rate-chart-scroll';
  region.tabIndex = 0;
  region.setAttribute('role', 'region');
  region.setAttribute('aria-label', 'OCR match-rate comparison; scroll horizontally on small screens');
  const svg = svgNode('svg', { viewBox: `0 0 630 ${sources.length * 40 + 75}`, role: 'img', 'aria-label': 'Election-keyword match rates by OCR source. Percentage of classified records, on a shared zero to one hundred percent scale. Exact counts follow in the table.' });
  svg.append(svgNode('title', {}, 'Screenshot OCR keyword match rates'));
  for (const value of [0, 25, 50, 75, 100]) {
    const x = 175 + value * 3;
    svg.append(svgNode('text', { x, y: 25, 'text-anchor': 'middle' }, `${value}%`));
    svg.append(svgNode('line', { x1: x, x2: x, y1: 35, y2: sources.length * 40 + 35, stroke: '#d9dde4' }));
  }
  sources.forEach(([, source], index) => {
    const y = index * 40 + 48;
    svg.append(svgNode('text', { x: 5, y: y + 15 }, source.label));
    const rate = source.match_percentage;
    const measured = source.status === 'available' && source.classified_records > 0 && typeof rate === 'number' && Number.isFinite(rate) && rate >= 0 && rate <= 100;
    if (measured) {
      const bar = svgNode('rect', { x: 175, y, width: rate * 3, height: 22, fill: '#3230cc', 'data-rate': rate });
      bar.append(svgNode('title', {}, `${source.label}: ${rate.toFixed(2)}%; ${source.matched_records} of ${source.classified_records} classified records`));
      svg.append(bar, svgNode('text', { x: 490, y: y + 16 }, `${rate.toFixed(2)}%`));
    } else {
      let status = 'Unavailable';
      if (source.status === 'empty') status = 'No observations';
      if (source.status === 'available') status = 'No classified records';
      svg.append(svgNode('text', { x: 185, y: y + 16 }, status));
    }
  });
  region.append(svg);
  return region;
}
